export enum TicketImportMode {
  IMPORT = 'IMPORT',
  GENERATE = 'GENERATE',
}
